import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { PlaceholderPage } from '@/components/layout/PlaceholderPage';

export const Route = createFileRoute('/_app/queue')({
	component: QueueRoute,
});

function QueueRoute() {
	const { t } = useTranslation();
	return (
		<PlaceholderPage
			title={t('nav.queue')}
			description={t('placeholder.queue.description')}
			scope={t('placeholder.queue.scope')}
		/>
	);
}
